import { FC, PropsWithChildren, useState, useMemo } from 'react';

import { AppModalContext, AppModalData } from './AppModal.context';
import { AppModal } from './AppModal';

type AppModalProviderProps = PropsWithChildren<{}>;

export const AppModalProvider: FC<AppModalProviderProps> = ({ children }) => {
    const [modalData, setModalData] = useState<AppModalData | null>(null);

    const contextValue = useMemo(() => {
        return {
            modalData,
            setModalData,
        };
    }, [modalData]);

    return (
        <AppModalContext.Provider value={contextValue}>
            {children}
            <AppModal />
        </AppModalContext.Provider>
    );
};
